import { TicketEmailSettingsEffects } from 'src/app/root-store/tickets-store/effects/ticket-email-settings.effects';

export const ticketEmailSettingsEffects = [TicketEmailSettingsEffects];
